import {SET_CONFIG} from "@/core/store/modules/config/constants";

export default {
    [SET_CONFIG](state, config) {
        Object.assign(state, config)
    },
}